import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from "@angular/forms"; 

export interface ProductActions {

  onDecrease(): void;

  onIncrease(): void;

}

/**
 *
 */
export type ButtonType = 'stroked' | 'flat' | 'raised' | undefined;


@Component({
  selector: 'btx-product-actions',
  templateUrl: './product-actions.component.html',
  styleUrls: ['./product-actions.component.scss'],
  standalone: false
})
export class ProductActionsComponent implements ProductActions, OnInit {

  @Input() group: FormGroup | any;


  @Input() buttonType: ButtonType = 'raised';

  @Input() label: string = 'shared.labels.choose';

  @Input() maxQuantity: string | any = 1;

  @Input() selectedQuantity: number = 0;

  @Input() seatControls: number[] = [];

  @Input() expanded: boolean = false;

  @Input("grouped") grouped: boolean = false;//group halinde toplam adet kontrol edilecek se true değilse false

  @Output() valueChange = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit(): void {
  }

  /**
   *
   */
  onDecrease() {
    let n = this.quantity;

    if (this.seatControls && this.seatControls.length > 0) {
      if (n > 0) {
        let index = this.seatControls.indexOf(n);
        if (index > 0) {
          this.setQuantity(this.seatControls[--index]);
        } else {
          this.setQuantity(0);
        }
      }
    } else {
      //seat control yoksa;
      this.setQuantity(--n);
    }

    this.expanded = n != 0;
  }

  /**
   *
   */
  onIncrease() {
    if (!this.disabled) {
      this.expanded = true;
      let n = this.quantity;

      if (this.seatControls && this.seatControls.length > 0) {
        if (n > 0) {
          let index = this.seatControls.indexOf(n);
          this.setQuantity(this.seatControls[++index]);
        } else {
          this.setQuantity(this.seatControls[0]);
        }
      } else {
        //seat control yoksa
        this.setQuantity(++n);
      }


    }
  }


  get quantity(): number {
    return this.group?.value.quantity ?? 0;
  }

  setQuantity(n: number) {
    const curQuantity = this.group.get("quantity").value;
    this.valueChange.emit(curQuantity?n-curQuantity:n);

    this.group.patchValue({
      quantity: n
    }
    );

  }

  get isExpanded(): boolean {
    return this.expanded && this.quantity != 0;
  }

  get disabled(): boolean {

    if (this.seatControls && this.seatControls.length > 0 && this.quantity >= this.seatControls[this.seatControls.length - 1]) {
      return true;
    }

    if (this.grouped && this.selectedQuantity >= this.maxQuantity) {
      return true;
    }

    if (!this.grouped && this.quantity >= this.maxQuantity) {
      return true;
    }

    return false;
  }

  get decraseBtnClassName(): string {
    if (this.seatControls && this.seatControls.length > 0) {
      if (this.quantity == this.seatControls[0]) {
        return 'delete';
      } else {
        return 'remove';
      }
    } else {
      //seat control yoksa
      if (this.quantity > 1) {
        return 'remove';
      } else {
        return 'delete'
      }

    }
  }

  get buttonClassName(): string | string[] {
    let classNames: string[] = [`mat-${this.buttonType}-button`];
    if (this.buttonType == "stroked") {
      classNames.push('btn-add-to-cart');
    }
    return classNames;
  }
}
